import CampaignList from "../components/CampaignList.jsx";
import CampaignMetricCards from "../components/CampaignMetricCards.jsx";
import {
  ActivityMetricCards,
  InventoryMetricCards,
} from "../components/InventoryMetricCards.jsx";
import { buildCampaignMetrics } from "../utils/history.js";
import { RefreshIcon } from "../components/Icons.jsx";
import { SUMMARY_CAMPAIGN_LIMIT } from "../constants.js";
import "../styles/summary.css";

export default function SummaryPage({
  campaignState,
  metricsState,
  onRefresh,
}) {
  const campaignMetrics = buildCampaignMetrics(campaignState.campaigns);

  return (
    <main className="cg-page-shell">
      <div className="cg-page-frame">
        <section className="cg-panel cg-page-card cg-page-panel">
          <section className="cg-summary-overview" aria-labelledby="campaign-overview-title">
            <div className="cg-panel-header">
              <div>
                <span className="cg-kicker">Campaign activity</span>
                <h2 id="campaign-overview-title">Recent campaign overview</h2>
                <p className="cg-muted-text">
                  Campaign counts below reflect the {SUMMARY_CAMPAIGN_LIMIT} most recent campaigns.
                </p>
              </div>
              <button type="button" className="cg-page-refresh-button" onClick={onRefresh}>
                <RefreshIcon />
                Refresh data
              </button>
            </div>
            <CampaignMetricCards metrics={campaignMetrics} loading={campaignState.loading} />
          </section>

          <section className="cg-subpanel">
            <div className="cg-panel-header">
              <div>
                <span className="cg-kicker">Campaigns</span>
                <h2>Recent campaigns</h2>
              </div>
            </div>
            <CampaignList
              campaigns={campaignState.campaigns}
              loading={campaignState.loading}
              error={campaignState.error}
            />
          </section>

          <section className="cg-subpanel">
            <div className="cg-panel-header">
              <div>
                <span className="cg-kicker">Code availability</span>
                <h2>Current code inventory</h2>
                <p className="cg-muted-text">
                  Current code inventory is calculated separately across all codes.
                </p>
              </div>
            </div>
            {metricsState.error ? (
              <div className="cg-inline-feedback cg-inline-feedback-error">
                <span>{metricsState.error}</span>
                <button type="button" onClick={onRefresh}>Try again</button>
              </div>
            ) : null}
            <InventoryMetricCards
              inventory={metricsState.inventory}
              loading={metricsState.loading}
            />
          </section>

          <section className="cg-subpanel">
            <div className="cg-panel-header">
              <div>
                <span className="cg-kicker">Last 7 days</span>
                <h2>Code activity</h2>
              </div>
            </div>
            <ActivityMetricCards activity={metricsState.activity} loading={metricsState.loading} />
          </section>
        </section>
      </div>
    </main>
  );
}
